// extracted by mini-css-extract-plugin
module.exports = {"card":"Cards_card__2R21_","resetMargins":"Cards_resetMargins__zeVpJ"};